'use strict';

var polyfill = require('./polyfill.js');
var index = require('../define-properties/index.js');

var getPolyfill = polyfill;
var define = index;

var shim = function shimEntries() {
	var polyfill = getPolyfill();
	define(Object, { entries: polyfill }, {
		entries: function testEntries() {
			return Object.entries !== polyfill;
		}
	});
	return polyfill;
};

module.exports = shim;
